import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core'
import { Subject, Subscription } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

/**
 * directive is used on buttons to prevent double click
 * Implementation according: https://coryrylan.com/blog/creating-a-custom-debounce-click-directive-in-angular
 *
 * Output:
 * debounceClick: Event emitter which fires once after 500 ms have been passed, no matter how many clicks have been received.
 *
 * How does it work:
 * Directive may be aplied on clickable elements for which double clicks should be prevented (e.g. exportable() in DynamicTable).
 * If applied, the click event will be passed to here. After 500ms the debounceClick event will be fired only once, no matter how many clicks have been received meanwhile.
 * Given this in the parent component methods have to be called via (debounceClick)="doSomething()" (instead of (click)="doSomething")
 *
 */

@Directive({
  selector: '[jmlLibDebounceDblClick]'
})
export class DebounceDblClickDirective implements OnInit {
  @Output() debounceClick = new EventEmitter()
  private clicks = new Subject()
  private subscription: Subscription

  constructor() {}

  ngOnInit() {
    this.subscription = this.clicks.pipe(debounceTime(500)).subscribe((e) => this.debounceClick.emit(e))
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault()
    event.stopPropagation()
    this.clicks.next(event)
  }
}
